import { CapacityReportStatus } from '@libs/services/graphql/generated/ala-backend.service';
import { Expose, plainToInstance, Transform, Type } from 'class-transformer';
import { BED_TYPE_META } from '../maps-v2/bed-type-meta.map';
import { EmptyBedReasonsDto } from './empty-reasons.dto';
import { FacilityBedRowDto } from './facility-bed-row.dto';

export class FacilityBedsDto {
  @Expose() id!: string;
  @Expose() facilityId!: number;
  @Expose() facilityCity!: string;
  @Expose() facilityName!: string;
  @Expose() facilityHasSmokingPolicy!: boolean | undefined;
  @Expose() noChangesFromPreviousReport!: boolean;
  @Expose() status!: CapacityReportStatus;

  @Expose({ name: 'capacityReportPeriodStartDate' })
  @Transform(({ value }) => new Date(value))
  datePeriodStart!: Date;

  @Expose({ name: 'capacityReportPeriodEndDate' })
  @Transform(({ value }) => new Date(value))
  datePeriodEnd!: Date;

  @Expose({ name: 'capacityReportPeriodDueDate' })
  @Transform(({ value }) => new Date(value))
  dateDue!: Date;

  @Expose({ name: 'submittedAt' })
  @Transform(({ value }) => (value ? new Date(value) : undefined))
  completedOn?: Date;

  @Expose({ name: 'submittedByName' })
  reporter?: string;

  @Expose() typeAHasEmptyBeds?: boolean;
  @Expose() typeBHasEmptyBeds?: boolean;
  @Expose() typeBSecureHasEmptyBeds?: boolean;
  @Expose() typeCHasEmptyBeds?: boolean;

  @Expose()
  @Type(() => EmptyBedReasonsDto)
  typeAEmptyBedReasons!: EmptyBedReasonsDto;
  @Expose()
  @Type(() => EmptyBedReasonsDto)
  typeBEmptyBedReasons!: EmptyBedReasonsDto;
  @Expose()
  @Type(() => EmptyBedReasonsDto)
  typeBSecureEmptyBedReasons!: EmptyBedReasonsDto;
  @Expose()
  @Type(() => EmptyBedReasonsDto)
  typeCEmptyBedReasons!: EmptyBedReasonsDto;

  // Consolidated output
  @Expose()
  @Transform(({ obj }) => {
    return [
      {
        ...BED_TYPE_META.A,
        fundedBedCount: obj.typeAFundedBedCount ?? null,
        hasEmptyBeds: obj.typeAHasEmptyBeds ?? null,
        emptyBedReasons: plainToInstance(
          EmptyBedReasonsDto,
          obj.typeAEmptyBedReasons,
          {
            excludeExtraneousValues: true,
          }
        ),
      },
      {
        ...BED_TYPE_META.B,
        fundedBedCount: obj.typeBFundedBedCount ?? null,
        hasEmptyBeds: obj.typeBHasEmptyBeds ?? null,
        emptyBedReasons: plainToInstance(
          EmptyBedReasonsDto,
          obj.typeBEmptyBedReasons,
          {
            excludeExtraneousValues: true,
          }
        ),
      },
      {
        ...BED_TYPE_META.BSecure,
        fundedBedCount: obj.typeBSecureFundedBedCount ?? null,
        hasEmptyBeds: obj.typeBSecureHasEmptyBeds ?? null,
        emptyBedReasons: plainToInstance(
          EmptyBedReasonsDto,
          obj.typeBSecureEmptyBedReasons,
          {
            excludeExtraneousValues: true,
          }
        ),
      },
      {
        ...BED_TYPE_META.C,
        hasEmptyBeds: obj.typeCHasEmptyBeds ?? null,
        fundedBedCount: obj.typeCFundedBedCount ?? null,
        emptyBedReasons: plainToInstance(
          EmptyBedReasonsDto,
          obj.typeCEmptyBedReasons,
          {
            excludeExtraneousValues: true,
          }
        ),
      },
    ] as FacilityBedRowDto[];
  })
  facilityBeds!: FacilityBedRowDto[];
}
